// ----------------------------------------------------------------------------
// Template: Collection
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/breadcrumbs/breadcrumbs';
import 'snippets/card/card';
import 'snippets/pagination/pagination';
import 'snippets/collection-driver/collection-driver';
import 'snippets/collection-filters-sort/collection-filters-sort';
import 'sections/page-hero/page-hero';
import 'sections/main-collection/main-collection';

// Sections below are built for page templates but are also placed on collection
// templates in the theme editor (e.g. collection.alpha-brain). A section's CSS and JS
// ship only via its own JS module, so without these imports they render unstyled and
// their swiper carousels never initialise. See the follow-up ticket for the full audit
// of section-to-template-bundle coverage.
import 'sections/statements-block/statements-block';
import 'sections/detailed-product/detailed-product';
import 'sections/compare-block/compare-block';
import 'sections/info-panel/info-panel';
import 'sections/faqs/faqs';